import React from "react";
import { withRouter } from "react-router";
import { PageHeader } from "../../components/analytics-kit";
import { TemplatesList } from "../content/templates";

// Settings, Content, Templates (CONTENT_HUB_TEMPLATES_2026-10-01): the workspace's piece recipes.
class TemplatesSettings extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view settings-view"
    }, /*#__PURE__*/React.createElement(PageHeader, {
      crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
        style: {
          cursor: "pointer"
        },
        onClick: () => this.props.history.push("/Settings")
      }, "Settings"), " \xB7 Content"),
      title: "Templates",
      subtitle: "Recipes for pieces: the channel, the shape of the copy and the media. The Builder applies them to any story; the words always come from the story."
    }), /*#__PURE__*/React.createElement("div", {
      className: "wa-card c12"
    }, /*#__PURE__*/React.createElement(TemplatesList, null)));
  }
}
export const TemplatesSettingsViewComponent = withRouter(TemplatesSettings);
export default TemplatesSettingsViewComponent;